export default "__VITE_ASSET__ba857dbd__"